var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g({ staticClass: "show-more", class: _vm.classes }, _vm.$listeners),
    [
      _c(
        "div",
        { ref: "content", staticClass: "show-more__content", style: _vm.style },
        [_c("div", { staticClass: "show-more__overlay" }), _vm._t("default")],
        2
      ),
      _c(
        "p",
        { staticClass: "show-more__button-container" },
        [
          _vm._t("button", [
            _c(
              "button",
              {
                staticClass: "show-more__button link link--secondary",
                attrs: { secondary: "" },
                on: { click: _vm.toggle }
              },
              [
                _c("span", { staticClass: "link__content" }, [
                  _vm._v(_vm._s(_vm.isExpanded ? "Show Less" : "Show More"))
                ])
              ]
            )
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }